import { State, ORDERS_FEATURE_KEY } from './orders.reducers';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectOrdersState = createFeatureSelector<State>(
  ORDERS_FEATURE_KEY
);
export const selectCurrentOrder = createSelector(
  selectOrdersState,
  state => state.currentOrder
);
export const selectOrderDetails = createSelector(
  selectOrdersState,
  state => state.orderDetails
);
export const getOrders = createSelector(
  selectOrdersState,
  state => state.ordersHistory
);
export const selectSubscriptions = createSelector(
  selectOrdersState,
  state => state.subscriptions
);
export const selectOrdersModal = createSelector(
  selectOrdersState,
  state => state.orderModal
);

// return true if any of the objects under orders has loading attribute to true
export const isLoading = createSelector(selectOrdersState, state =>
  Object.keys(state).some(key => state[key].loading)
);
